import { render, staticRenderFns } from "./LoaderPartial.vue?vue&type=template&id=645167d6&scoped=true&"
import script from "./LoaderPartial.vue?vue&type=script&lang=js&"
export * from "./LoaderPartial.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPartial.vue?vue&type=style&index=0&id=645167d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645167d6",
  null
  
)

export default component.exports